import React from 'react';
import ShopHero from '../components/shop/ShopHero';
import LogoCarousel from '../components/shop/LogoCarousel';
import ReadyToGetStarted from '../components/shop/ReadyToGetStarted';
import FAQ from '../components/shop/FAQ';
import CustomisationTechniques from '../components/shop/CustomisationTechniques';
import HowItWorks from '../components/home/HowItWorks';
import ShopShowroomBand from '../components/shop/ShopShowroomBand';

const steps = [
  {
    title: 'Submit your quote request',
    text: 'Browse our online product range or visit our showroom to choose your products. Need help choosing? Reach out to a member of our team.',
  },
  {
    title: 'Design and customise',
    text: 'Our team will work with you on your artwork. Choose from our Professional Design Service, Artwork Check & Set-Up, or supply your own Print Ready Files.',
  },
  {
    title: 'Order confirmation',
    text: 'After you confirm your final artwork proof, we will progress your order to our production department.',
  },
  {
    title: 'Production and delivery',
    text: 'Production usually takes 5 to 10 working days. Want it sooner? Talk to us. We will let you know when your order is dispatched or ready for collection.',
  },
];

const NewShopFrontPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    {/* Hero: showroom photo + category strips */}
    <ShopHero />

    {/* The USP strip that sat here repeated the header's green strapline, so it went (2026-09-26). */}

    {/* Types of Customisation */}
    <CustomisationTechniques />

    {/* Brands we supply — the names people recognise, before we ask them to order */}
    <LogoCarousel speed={50} />

    {/* Showroom band — 4000 styles / 100 brands, 200+ garments on display */}
    <ShopShowroomBand />

    <HowItWorks steps={steps} tone="dark" />

    {/* FAQ + CTA */}
    <FAQ />
    <ReadyToGetStarted />
  </div>
);

export default NewShopFrontPage;
